import React from "react";
import { StatusBadge } from "../../../../shared/components/badges/StatusBadge";
import { ExpandedAccordion } from "../../../../shared/components/ui/ExpandedAccordion";

const TalukaExpandedRow = ({ item }) => {
  const sections = [
    {
      id: "basic",
      title: "Basic Info",
      fields: [
        { label: "Taluka Name", value: item.name || "—" },
        { label: "District", value: item.district?.name || "—" },
        { label: "Taluka Code", value: item.talukaCode || "—" },
        { label: "Status", value: item.status ? <StatusBadge status={item.status} /> : "—" },
      ],
    },
    {
      id: "contact",
      title: "Contact Info",
      fields: [
        { label: "Contact Person", value: item.contactPerson || "—" },
        { label: "Phone Number", value: item.phone || "—" },
        { label: "Email", value: item.email || "—" },
        { label: "Office Address", value: item.officeAddress || "—", isLong: true },
      ],
    },
  ];

  return <ExpandedAccordion sections={sections} />;
};

export default TalukaExpandedRow;
